module.exports = __webpack_public_path__ + "static/media/60182f5c9e9d2a1f6fead710_classlink-icon-symbol-large.25e0b706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/branding/60182f5c9e9d2a1f6fead710_classlink-icon-symbol-large.png
// module id = 2191
// module chunks = 0